import React from 'react';
import './ui.css';

export function YSelect({ id, value, onChange, children, disabled = false, invalid = false, className = '' }) {
  return (
    <select
      id={id}
      className={`y-select ${invalid ? 'is-invalid' : ''} ${className}`.trim()}
      value={value}
      onChange={onChange}
      disabled={disabled}
    >
      {children}
    </select>
  );
}
